import React, { useEffect, useState } from "react";
import { getPageData } from "../api/pageService";
import { getCompanyInfo, getSocialLinks } from "../api/companyService";
import { sleep } from "../utils/sleep";
import { Title, Meta, Link as SeoLink } from "react-head";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaQuoteLeft } from "react-icons/fa";
import ContactForm from "../components/ContactForm";
import * as Icons from "react-icons/fa";

const ContactUs = () => {
  const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    const fallBackSocialLinks = [
  { platform: "facebook", icon:"FaFacebookF", url: "https://www.facebook.com/softition" },
  { platform: "twitter", icon:"FaTwitter", url: "https://x.com/softition" },
  { platform: "linkedin", icon:"FaLinkedinIn", url: "https://www.linkedin.com/company/softition/" },
  { platform: "instagram", icon:"FaInstagram", url: "https://www.instagram.com/softitionsolutions/" },
];

    const [companyInfo, setCompanyInfo] = useState(null);
      const [companyInfoLoading, setCompanyInfoLoading] = useState(true);
      const [companyInfoError, setCompanyInfoError] = useState(null);
    
      const [socialLinks, setSocialLinks] = useState([]);
      const [socialLinksLoading, setSocialLinksLoading] = useState(true);
  const [socialLinksError, setSocialLinksError] = useState(null);
  
  useEffect(() => {
    
          const fetchPageData = async () => {
            try {
              // simulate network delay (3 sec)
              //await sleep(3000);
    
              const data = await getPageData("contact"); // asynchronous call
              setPageData(data);
            } catch (err) {
              setError("Failed to load contact page data.");
            } finally {
              setLoading(false);
            }
          };
          
    const fetchCompanyInfo = async () => {
          try {
            //await sleep(1000);
            const data = await getCompanyInfo(); // new API
            setCompanyInfo(data);
          } catch (err) {
            setCompanyInfoError("Failed to load company info.");
          } finally {
            setCompanyInfoLoading(false);
          }
        };
    
        const fetchSocialLinks = async () => {
          try {
            //await sleep(1000);
            const data = await getSocialLinks(); // new API
            setSocialLinks(data);
          } catch (err) {
            setSocialLinksError("Failed to load company info.");
          } finally {
            setSocialLinksLoading(false);
          }
        };
      

        fetchCompanyInfo();
        fetchSocialLinks();
          fetchPageData();
    }, []);
  
  return (
    <>
      <Title>{pageData? pageData.seo.title:''}</Title>
            <Meta
              name="description"
              content={pageData?pageData.seo.description:''}
            />
      <SeoLink rel="canonical" href={pageData ? pageData.seo.canonical : ''} />
      
      {/* Contact Section */}
      <section className="bg-light py-5">
        <div className="container">
          
          {(loading || error) ? (
          <div className="text-center">
          <h2 className="fw-bold placeholder-glow">
            <span className="placeholder col-4 nav-placeholder">&nbsp;</span>
          </h2>
          <p className="text-muted small ps-3 mb-5 placeholder-glow">
             <span className="placeholder col-4 nav-placeholder">&nbsp;</span>
          </p>
        </div>
          ) : (
           <div className="text-center">
            <h1 className="fw-bold">{pageData?pageData.hero.heading:''} <span className="text-primary-color">{pageData?pageData.hero.highlight:''}</span></h1>
            <p className="text-muted small ps-3 mb-5">
             {pageData?pageData.hero.description:''}
            </p>
          </div>
          )}

          <div className="row g-5">
            {/* Form */}
            <div className="col-lg-7">
              <ContactForm/>
            </div>

            {/* Info */}
            <div className="col-lg-5">
              {(companyInfoLoading || companyInfoError) ? (
                          <div className="p-4 rounded-4 shadow-lg mb-4">
                <h5 className="fw-bold mb-4 text-primary-color">
                    Let's Connect
                  </h5>
                                    <p className="placeholder-glow">
                                      <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
                            </p>
                            <p className="placeholder-glow">
                                      <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
                            </p>
                            <p className="placeholder-glow">
                                      <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
                  </p>
                  <p className="placeholder-glow">
                                      <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
                            </p>
                            </div>
                        ) : (
                            <div className="p-4 rounded-4 shadow-lg mb-4">
                <h5 className="fw-bold mb-4 text-primary-color">
                    Let's Connect
                  </h5>
                <p className="mb-3"><FaMapMarkerAlt className="me-2 text-accent" />{ companyInfo? companyInfo.contact.address:''}</p>
                <p className="mb-3"><FaPhoneAlt  className="me-2 text-accent" /> { companyInfo? companyInfo.contact.phone:''}</p>
                <p className="mb-3"><FaEnvelope className="me-2 text-accent" /> { companyInfo? companyInfo.contact.email:''}</p>

                 {/* Classy Quote */}
                  <blockquote className="border-start ps-3 fst-italic text-muted small">
                    <FaQuoteLeft className="me-2 text-primary-color" />
                    { companyInfo? companyInfo.contact.quote:''}
                  </blockquote>
              </div>
                        )}
              

              <h6 className="fw-bold mb-3">Follow Us</h6>
              <div className="d-flex gap-3">
                {((socialLinksError || socialLinksLoading) ? fallBackSocialLinks : socialLinks).map((link, idx) => {
                               const Icon = Icons[link.icon]; // dynamically select icon  
                              return (
                                <>
                                    {(socialLinksLoading || socialLinksError) ? (
                                      <div className="placeholder-glow me-2 social-circle-footer"></div>
                                  ) : (
                                     <a key={idx} href={link.url} className="social-circle" target="_blank" rel="noreferrer">
                                      {Icon ? <Icon /> : null}
                                    </a>
                                    )}
                                  
                                </>
                              );
                            })}
              </div>
            </div>
          </div>
        </div>
      </section>

     {/* Premium Google Map */}
      <div className="golden-map-wrapper">
        <iframe
          title="Google Map"
          src={ companyInfo? companyInfo.mapUrl:''}
          style={{
            border: 0,
            width: "100%",
            height: "400px",
            borderRadius: "12px",
          }}
          allowFullScreen
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe> 
      </div>
    </>
  );
};

export default ContactUs;
